export default __webpack_public_path__ + "static/media/loading-stars.4a01da25.svg";